/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

const ContentArea = ({ children, className, style, whiteScroll }) => (
  <div
    {...{ children, className, style }}
    styleName={classNames('root', {
      'root--whiteScroll': whiteScroll,
    })}
  />
);

ContentArea.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  whiteScroll: PropTypes.bool,
};

export default CSSModules(ContentArea, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/ContentArea/index.jsx